import Vue from "vue";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/CatatanPemberianObat";

interface CatatanPemberianObat {
  kode: string;
  tgl: string;
}

function findRow(list: any[], kodeObat: string): any {
  return (list || []).find(r => String(r.kode_obat) === String(kodeObat));
}

function findPemberian(row: any, id: number | string): any {
  if (!row || !Array.isArray(row.pemberian)) {
    return null;
  }
  return row.pemberian.find(p => Number(p.id) === Number(id));
}

function applyPatch(target: any, patch: Record<string, any>): void {
  Object.keys(patch || {}).forEach(key => Vue.set(target, key, patch[key]));
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "catatan-pemberian-obat"
})
class CatatanPemberianObatStore extends VuexModule {
  loading = false;
  data: CatatanPemberianObat = null;
  dataList: CatatanPemberianObat[] = [];
  registerId: string = null;

  @Mutation
  SET_RECORD(val) {
    this.data = val;
  }

  @Mutation
  SET_REGISTER_ID(val: string) {
    this.registerId = val;
  }

  @Mutation
  SET_DATALIST(val: CatatanPemberianObat[]) {
    this.dataList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.data = null;
    this.dataList = [];
    this.registerId = null;
  }

  @Mutation
  PATCH_ITEM(payload: { kodeObat: string; patch: Record<string, any> }) {
    const row = findRow(this.dataList as any[], payload.kodeObat);
    if (row) {
      applyPatch(row, payload.patch);
    }
  }

  @Mutation
  ADD_PEMBERIAN(payload: { kodeObat: string; pemberian: any }) {
    const row = findRow(this.dataList as any[], payload.kodeObat);
    if (!row) {
      return;
    }
    if (!Array.isArray(row.pemberian)) {
      Vue.set(row, "pemberian", []);
    }
    row.pemberian.push(payload.pemberian);
  }

  @Mutation
  PATCH_PEMBERIAN(payload: {
    kodeObat: string;
    id: number;
    patch: Record<string, any>;
  }) {
    const pemberian = findPemberian(
      findRow(this.dataList as any[], payload.kodeObat),
      payload.id
    );
    if (pemberian) {
      applyPatch(pemberian, payload.patch);
    }
  }

  @Mutation
  REMOVE_PEMBERIAN(payload: { kodeObat: string; id: number }) {
    const row = findRow(this.dataList as any[], payload.kodeObat);
    if (!row || !Array.isArray(row.pemberian)) {
      return;
    }
    const idx = row.pemberian.findIndex(
      (p: any) => Number(p.id) === Number(payload.id)
    );
    if (idx >= 0) {
      row.pemberian.splice(idx, 1);
    }
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    const reg = registerId == null ? null : String(registerId);

    if (this.registerId !== reg) {
      this.RESET_STORE();
    }

    this.SET_REGISTER_ID(reg);
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    if (this.registerId !== reg) {
      return;
    }

    this.SET_DATALIST(response.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(CatatanPemberianObatStore);
